import { Spacing } from "components/designV2/constants";
import { H4 } from "components/Typography/text.styled";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled from "styled-components";

export const SECTION_TRANSITION_MS = 250;

export const FieldsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  @media (max-width: 560px) {
    grid-template-columns: minmax(0, 1fr);
  }
`;

export const EmploymentTypeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FooterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${Spacing.sm}px;
`;

export const SubmitErrorText = styled.p`
  ${TypographyV2.s1}
  color: ${ColorV2.NegativeRed};
  margin: 0;
  text-align: center;
`;

export const SectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: ${ColorV2.White};
  border-radius: 16px;
`;

export const CollapsibleWrapper = styled.div<{ $collapsed: boolean }>`
  width: 100%;
  display: grid;
  grid-template-rows: ${(props) => (props.$collapsed ? "0fr" : "1fr")};
  transition: grid-template-rows ${SECTION_TRANSITION_MS}ms ease-in-out;
`;

// `visibility` keeps a collapsed section's fields out of the tab order now that
// they stay mounted. Hiding is delayed until the row has finished shrinking so
// the content does not blink out at the start of a collapse; showing is
// immediate, so an opening section is reachable from the first frame.
export const CollapsibleContent = styled.div<{ $collapsed: boolean }>`
  overflow: hidden;
  visibility: ${(props) => (props.$collapsed ? "hidden" : "visible")};
  transition: visibility 0s
    ${(props) => (props.$collapsed ? `${SECTION_TRANSITION_MS}ms` : "0s")};
`;

export const SectionBodyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.md}px;
  width: 100%;
  padding: ${Spacing.md}px;
`;

export const SectionHeaderWrapper = styled.div<{ $locked: boolean }>`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${Spacing.md}px;
  padding: ${Spacing.md}px;
  cursor: ${(props) => (props.$locked ? "not-allowed" : "pointer")};
`;

export const SectionTitle = styled(H4)<{ $locked: boolean }>`
  margin: 0;
  ${(props) => props.$locked && `color: ${ColorV2.Blue5};`}
`;

export const IconsWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: ${Spacing.md}px;
`;

export const CompletedBadge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 ${Spacing.sm}px;
  border-radius: 999px;
  background-color: ${ColorV2.PositiveGreenLight};
`;
